import { render, staticRenderFns } from "./隐私政策.vue?vue&type=template&id=04aa501b&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./隐私政策.vue?vue&type=script&lang=js"
export * from "./隐私政策.vue?vue&type=script&lang=js"
import style0 from "./隐私政策.vue?vue&type=style&index=0&id=04aa501b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa501b",
  null
  
)

export default component.exports